import React from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Typography, Box, Button } from '@mui/material';
import { Close } from '@mui/icons-material';

interface AgreementModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  pdfUrl: string;
  onAccept: () => void;
  isAccepted: boolean;
}

const AgreementModal: React.FC<AgreementModalProps> = ({ open, onClose, title, pdfUrl, onAccept, isAccepted }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', bgcolor: '#f8f9fa' }}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>{title}</Typography>
        <IconButton onClick={onClose} size="small">
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 0, height: '70vh', display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ flex: 1, overflow: 'hidden' }}>
          {/* Using object tag or iframe with #toolbar=0 to disable download buttons in most modern browsers */}
          <iframe 
            src={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=0`} 
            width="100%" 
            height="100%" 
            style={{ border: 'none' }}
            title={title}
          />
        </Box>
        <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid #dee2e6', bgcolor: '#fff' }}>
          <Button 
            variant="outlined" 
            color="inherit" 
            onClick={onClose}
            sx={{ mr: 2 }}
          >
            Close
          </Button>
          {!isAccepted ? (
            <Button 
              variant="contained" 
              color="primary" 
              onClick={() => {
                onAccept();
                onClose();
              }}
            >
              I Accept the Agreement
            </Button>
          ) : (
            <Button 
              variant="contained" 
              color="success" 
              disabled
            >
              Agreement Accepted
            </Button>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default AgreementModal;
